import { Component, OnInit } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { RespLogout } from "src/app/giz-library/auth/model/auth.model";
import { AuthService } from "src/app/giz-library/auth/service/auth.service";
import { MatDialog } from '@angular/material/dialog';
import { AuthSigInComponent } from "src/app/giz-library/auth/auth-sig-in/auth-sig-in.component";
import { UserService } from "src/app/giz-library/user/service/user.service";
import { throwError } from "rxjs";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class AppHeaderComponent implements OnInit {
  constructor(

    private router: Router,
    public dialog: MatDialog,
    private authService: AuthService,
    private userService: UserService
  ) { }

  user_id!: string | null;

  ngOnInit(): void { }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }


  getUsername() {
    const _username = this.authService.getUsername();
    const myArray = _username?.split("@");
    const _mini_username = myArray![0];
    return _mini_username;
  }

  logOut() {
    this.authService.logout().subscribe((_response: RespLogout) => {
      if (_response.status) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(["/inicio"]).then(() => {
          })
        })
      }
    });

  }

  openDashboard() {
    // window.open("https://wikipapa.org/sec/dashboard/", "_blank");
    window.open("https://wikipapa.org/dashboard", "_blank");
  }

  fnIsRole(role: string) {
    return this.authService.isRole(role);
  }

  login() {
    const dialogRef = this.dialog.open(AuthSigInComponent, {
      data: { input: null },
      width: '370px',

    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  fnGoToView(_route: string, _have_params: boolean = false) {
    if (_have_params) {
      const _user_id = this.authService.getUserId();
      this.userService.getUserById(_user_id).subscribe(
        (x) => {
          const _params = {
            p_user_id: _user_id,
            p_username: x.data.username
          };
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([_route], {
              queryParams: _params
            }).then(() => {
            })
          });
        }
      );
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([_route]).then(() => {
        })
      })
    }
  }
}


